import { useQuery } from '@tanstack/react-query';
import type { ContentCalendarItem, CursorPage } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useCalendarItems(calendarId: string | undefined) {
  return useQuery({
    queryKey: ['calendar-items', calendarId],
    queryFn: () => apiGet<CursorPage<ContentCalendarItem>>(`/v1/calendars/${calendarId}/items`),
    enabled: !!calendarId,
    refetchInterval: 10_000,
  });
}
